import React from "react";
import { Grid } from "@mui/material";
import { Custom } from "components";
import { useApp } from "context";
import { useForm } from "hooks";
import { Enums, Helpers, Routes } from "utils";
import { IPatient } from "interfaces";

type Props = {
  patient: IPatient | null;
  onClose: () => void;
};

export const ResetPasswordAdmin = (props: Props) => {
  const { t, theme, setFeedback, service } = useApp();

  const initialState = { password: "" };

  const { onChange, onSubmit, values } = useForm(submitCallback, {
    initialState,
  });

  async function submitCallback() {
    const { password }: any = values;

    const [status, response] = await service.auth.resetPasswordByAdmin(
      props.patient?.patientId as number,
      password
    );

    if (status === Enums.EnumResponse.Success) {
      setFeedback({
        message: t.message.auth.password_updated,
        severity: Enums.EnumFeedback.Success,
      });

      props.onClose();
    } else {
      setFeedback({
        message: t.message.feedback.request_error,
        severity: Enums.EnumFeedback.Error,
      });
    }
  }

  return (
    <form onSubmit={onSubmit}>
      <div className="qh-form">
        <Grid container spacing={theme.margin.md}>
          <Grid item xs={12} sm={6}>
            <Custom.TextField
              name="name"
              label={t.label.name}
              value={Helpers.replaceComma(props.patient?.username ?? "")}
              readOnly
            />
          </Grid>

          <Grid item xs={0} sm={1}></Grid>

          <Grid item xs={12} sm={6}>
            <Custom.TextField
              name="email"
              label={t.label.email}
              value={props.patient?.email}
              readOnly
            />
          </Grid>

          <Grid item xs={0} sm={1}></Grid>

          <Grid item xs={12} sm={6}>
            <Custom.TextField
              name="password"
              required={true}
              onChange={onChange}
              label={t.label.password}
            />
          </Grid>
        </Grid>
      </div>
      <div style={{ marginTop: "1em" }}>
        <Custom.Button submit>{t.action.submit}</Custom.Button>
      </div>
    </form>
  );
};
